import SegmentedButton from "./SegmentedButton";
import styles from "./m3.module.css";

/**
 * Workspace navigation row: segmented tabs on the left, actions (e.g. report export) on the right.
 *
 * @param {Array} tabs - SegmentedButton options ({ value, label, icon?, count?, disabled? })
 * @param {*} value - active tab value
 * @param {function} onChange - receives the new tab value
 * @param {React.ReactNode} actions
 */
const WorkspaceHeader = ({ tabs = [], value, onChange, actions, ariaLabel, showCheck = false }) => (
  <div className={styles.workspaceHeader}>
    <div className={styles.workspaceTabs}>
      <SegmentedButton options={tabs} value={value} onChange={onChange} ariaLabel={ariaLabel} showCheck={showCheck} />
    </div>
    {actions && <div className={styles.workspaceActions}>{actions}</div>}
  </div>
);

export default WorkspaceHeader;
